import React, { useState, useMemo } from "react";
import "./FastAddOppPlayer.css";
import { createOppPlayer } from "../../../services/player.services";
import { useSelector } from 'react-redux';

const CreateFastOppPlayerOverlay = ({
  isVisible,
  onClose,
  oid,
  playerData,
  refreshPlayers,
}) => {
  const user = useSelector(state => state.auth.user);

  const [selectedNumbers, setSelectedNumbers] = useState(new Set()); // Changed to Set for multiple selections
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const assignedNumbers = useMemo(() =>
    new Set(
      playerData?.map(p => parseInt(p?.playerNumber)).filter(num => !isNaN(num))
      ),[playerData])

  const handleAddPlayer = async () => {
    if (selectedNumbers.size === 0) return;

    try {
      setLoading(true);
      // Create all players in parallel
      await Promise.all(
        Array.from(selectedNumbers).map(number => {
          const payload = {
            teamId: oid,
            firstName: 'FastAdd',
            lastName: `Player#${number}`,
            playerName: `FastAdd Player#${number}`,
            playerNumber: number.toString(),
            position: 'None',
          };
          return createOppPlayer(payload, user?.token);
        })
      );
      
      await refreshPlayers();
      onClose();
      setSelectedNumbers(new Set()); // reset
    } catch (e) {
      setError(e);
      console.log('Error in Opponent Fast Add:', e.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCross = () => {
    setSelectedNumbers(new Set());
    onClose();
  };

  const toggleNumberSelection = (number) => {
    setSelectedNumbers(prev => {
      const newSelection = new Set(prev);
      if (newSelection.has(number)) {
        newSelection.delete(number);
      } else {
        newSelection.add(number);
      }
      return newSelection;
    });
  };
    return (
        <div className={`modal-fastAdd ${isVisible ? 'show' : ''}`}>
            {error && (
                <div className="error-overlay" onClick={() => setError(null)}>
                    <p>{error.message || "Something went wrong"}</p>
                </div>
            )}
            <div className="modal-content-fastAdd" style={{padding: '20px'}}>
                <div className="modal-header-fastAdd" style={{ marginBottom: '10px' }}>
                    <h2>FAST ADD PLAYER</h2>
                    <button className="cross-button" onClick={handleCross}>
                        ✖
                    </button>
                </div>
                <div className="grid">
                    {Array.from({ length: 100 }, (_, i) => i)
                        .filter((i) => !assignedNumbers.has(i))
                        .map((i) => (
                            <button
                                key={i}
                                className={`number-box ${selectedNumbers.has(i) ? "selected" : ""
                                    }`}
                                onClick={() => toggleNumberSelection(i)}
                            >
                                {i}
                            </button>
                        ))}
                </div>

                <button
                    className="add-button"
                    onClick={handleAddPlayer}
                    disabled={selectedNumbers.size === 0 || loading}
                >
                    {loading
                        ? "Loading..."
                        : `Add ${selectedNumbers.size > 0 ? `(${selectedNumbers.size})` : ""
                        }`}
                </button>
            </div>
        </div>
    );
};

export default CreateFastOppPlayerOverlay;
